import React from 'react'
import PropTypes from 'prop-types'

const initialState = null
const actions = {
  ADD_USER_COMPANY: 'ADD_USER_COMPANY',
  UPDATE_COMPANY: 'UPDATE_COMPANY',
}

const reducer = (state, action) => {
  switch (action.type) {
    case actions.ADD_USER_COMPANY:
      return action.payload
    case actions.UPDATE_COMPANY:
      return {
        ...state,
        companyId: action.payload.companyId,
        companyName: action.payload.companyName,
        isAgency: action.payload.isAgency,
        userTitle: action.payload.userTitle,
        companyEmail: action.payload.companyEmail,
        roleType: action.payload.roleType,
        isActive: action.payload.isActive,
      }
    default:
      return state
  }
}

const userContext = React.createContext(initialState)

function UserProvider({ children }) {
  const [state, dispatch] = React.useReducer(reducer, initialState)
  return (
    <userContext.Provider value={{ state, dispatch }}>
      {children}
    </userContext.Provider>
  )
}

UserProvider.propTypes = {
  children: PropTypes.node.isRequired,
}

export { userContext, UserProvider, actions }
